// material-ui
import { Theme } from '@mui/material/styles';
import { Box, Tab, useMediaQuery } from '@mui/material';

// project import
import Message from './Message';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// types
import { MenuOrientation } from 'types/config';
import Multilang from './Multilang';
import { Tabs } from '@mui/material';
import { useState } from 'react';

// ==============================|| HEADER - CONTENT ||============================== //

const PluginHeaderContent = () => {
  const { menuOrientation } = useConfig();

  const [value, setValue] = useState<number>(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      <Box sx={{ width: '100%', ml: 2 }}>
        <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label="Plugins" />
          <Tab label="SimExpert" />
          <Tab label="AuroraDB" />
          <Tab label="Aurora Analytics" />
          <Tab label="AuroraChat" />
          <Tab label="AuroraGeo" />
          <Tab label="AuroraSim" />
        </Tabs>
      </Box>

      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      <Multilang />
      <Notification />
      <Message />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default PluginHeaderContent;
